import { Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme: Theme) => ({
  container: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    color: theme.palette.primary.main,
    padding: "0 10rem",

    [theme.breakpoints.down("md")]: {
      padding: 0,
    },
  },
  containerBottom: {
    display: "block",
    padding: "8rem 10rem 0",
    color: theme.palette.primary.main,
  },
  extraPaddingBottom: {
    paddingBottom: theme.spacing(1),
  },
  borderBottom: {
    borderBottom: "2px solid",
    borderColor: theme.palette.primary.main,
  },
  main: {
    maxWidth: theme.spacing(55),
    paddingTop: theme.spacing(10),
    paddingBottom: theme.spacing(0),
    paddingLeft: theme.spacing(8),
    paddingRight: theme.spacing(8),

    [theme.breakpoints.down("md")]: {
      paddingTop: theme.spacing(4),
      paddingBottom: theme.spacing(4),
      paddingLeft: 0,
      paddingRight: theme.spacing(4),
    },
  },
  bottomSpace: {
    paddingBottom: theme.spacing(10),
  },
  yearContainer: {
    minWidth: theme.spacing(15),
    [theme.breakpoints.down("md")]: {
      minWidth: "auto",
    },
  },
  year: {
    fontSize: 45,
    fontWeight: 700,

    [theme.breakpoints.down("md")]: {
      fontSize: 30,
    },
  },
  yearBottom: {
    fontSize: 45,
    fontWeight: 700,
    paddingBottom: theme.spacing(2),
  },
  title: {
    fontSize: 30,
    fontWeight: 600,

    [theme.breakpoints.down("md")]: {
      fontSize: 20,
      padding: "0.5rem 0",
    },
  },
  titleBottom: {
    fontSize: 40,
    fontWeight: 600,
    paddingBottom: theme.spacing(2),
  },
  subtitle: {
    fontSize: 15,
    fontWeight: 700,

    [theme.breakpoints.down("md")]: {
      fontSize: 12,
    },

    "&::after": {
      content: '""',
      display: "block",
      width: theme.spacing(8),
      height: 2,
      background: theme.palette.primary.main,
      marginTop: theme.spacing(1),
    },
  },
  subtitleBottom: {
    fontSize: 30,
    fontWeight: 700,
    paddingBottom: theme.spacing(1),

    "&::after": {
      content: '""',
      display: "block",
      width: theme.spacing(16),
      height: 3,
      background: theme.palette.primary.main,
      marginTop: theme.spacing(1),
    },
  },

  text: {
    [theme.breakpoints.down("md")]: {
      fontSize: 13,
    },
  },
  textBottom: {
    fontSize: 20,
    [theme.breakpoints.down("md")]: {
      fontSize: 13,
    },
  },
  divider: {
    width: 2,
    minWidth: 2,
    alignSelf: "stretch",
    backgroundColor: theme.palette.primary.main,
    position: "relative",
    "&::before": {
      content: '" "',
      position: "absolute",
      left: -68,
      top: "50%",
      transform: "translate(0, -50%)",
      borderWidth: "40px 70px 40px 0",
      borderTopColor: "transparent",
      borderBottomColor: "transparent",
      borderLeftColor: theme.palette.primary.main,
      borderRightColor: theme.palette.primary.main,
    },
    "&::after": {
      content: '" "',
      position: "absolute",
      left: -54,
      top: "50%",
      transform: "translate(0, -50%)",
      borderWidth: "40px 70px 40px 0",
      borderColor: "transparent white transparent white",
    },
  },
  dividerReversed: {
    width: 2,
    minWidth: 2,
    alignSelf: "stretch",
    backgroundColor: theme.palette.primary.main,
    position: "relative",
    "&::before": {
      content: '" "',
      position: "absolute",
      right: -68,
      top: "50%",
      transform: "translate(0, -50%)",
      borderWidth: "40px 0 40px 70px",
      borderTopColor: "transparent",
      borderBottomColor: "transparent",
      borderLeftColor: theme.palette.primary.main,
      borderRightColor: theme.palette.primary.main,
    },
    "&::after": {
      content: '""',
      position: "absolute",
      right: -54,
      top: "50%",
      transform: "translate(0, -50%)",
      borderWidth: "40px 0px 40px 70px",
      borderColor: "transparent white transparent white",
    },
  },
  square: {
    position: "absolute",
    top: -8,
    left: -7,
    width: "1rem",
    height: "1rem",
    background: theme.palette.primary.main,
    transform: "rotate(45deg)",
    zIndex: 1,
  },
  bottomTriangle: {
    position: "absolute",
    left: -6,
    bottom: -8,
    width: 70,
    "&::before": {
      content: '" "',
      position: "absolute",
      bottom: -70,
      left: "-50%",
      // transform: "translate(-50%, 0)",
      borderWidth: "70px 40px 0 40px",
      borderTopColor: theme.palette.primary.main,
      borderBottomColor: theme.palette.primary.main,
      borderLeftColor: "transparent",
      borderRightColor: "transparent",
    },
    "&::after": {
      content: '""',
      position: "absolute",
      bottom: -60,
      left: "-50%",
      // transform: "translate(-50%, 0)",
      borderWidth: "70px 40px 0px 40px",
      borderColor: "white transparent white transparent",
    },
  },
  mobileTriangle: {
    width: theme.spacing(6),
    height: theme.spacing(7),
    marginTop: theme.spacing(3),
    borderWidth: "28px 48px 28px 0px",
    borderTopColor: "transparent",
    borderBottomColor: "transparent",
    borderLeftColor: theme.palette.primary.main,
    borderRightColor: theme.palette.primary.main,
  },
}));
